function ExternalRedirect() {
  window.location.href = "https://www.regent-dental.co.uk/full-arch";
  return null;
}
export default ExternalRedirect;